import { Injectable } from '@angular/core';
import { AppConfig } from './app-config.service';
import { CrispUser } from '../models/crisp.model';
import { AuthStoreService } from '../../shared/services/auth/auth-store.service';
import { CookieService } from 'ngx-cookie';
import { detect } from 'detect-browser';
import { Crisp } from 'crisp-sdk-web';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const browser = detect();

@Injectable({
  providedIn: 'root',
})
export class CrispService {
  constructor(private appConfig: AppConfig, private auth: AuthStoreService, private cookies: CookieService) {
  }

  public installCrisp(shouldReset = false): void {
    if (this.appConfig.config.analytics.crisp.enabled) {
      Crisp.configure(this.appConfig.config.analytics.crisp.websiteId);
      Crisp.setHideOnAway(false);
      Crisp.setHideOnMobile(false);
      if (shouldReset) {
        this.resetCrispSession();
      }
      this.setCrispAttributes();
    }
  }

  public resetCrispSession(): void {
    if (this.appConfig.config.analytics.crisp.enabled) {
      Crisp.session.reset();
    }
  }

  public setCrispAttributes(): void {
    if (this.appConfig.config.analytics.crisp.enabled) {
      // const crispUser = null;
      // const crispUser = this.mapToCrispUser();
      // if (crispUser) {
      //   Crisp.session.setData(crispUser);
      //   Crisp.user.setEmail(crispUser.email);
      //   Crisp.user.setNickname(crispUser.name);
      // }
    }
  }

  // private mapToCrispUser(): CrispUser {
  //   const { userInfo } = this.auth;
  //   const crispUser: CrispUser = !userInfo
  //     ? undefined
  //     : {
  //         name: userInfo.name,
  //         email: userInfo.email,
  //         externalId: userInfo.customer_id,
  //         lastSeenAt: `${Math.round(new Date().getTime() / 1000)}`,
  //         referralUrl: this.cookies.get(REFERRER),
  //         browser: browser.os,
  //         utmSource: this.cookies.get(UTM_SOURCE),
  //         utmMedium: this.cookies.get(UTM_MEDIUM),
  //         utmCampaign: this.cookies.get(UTM_CAMPAIGN),
  //         utmTerm: this.cookies.get(UTM_TERM),
  //         utmContent: this.cookies.get(UTM_CONTENT),
  //         referrer: this.cookies.get(REFERRER),
  //       };
  //
  //   const sanitizedUser = this.sanitizeCrispUser(crispUser);
  //   return sanitizedUser;
  // }
  private sanitizeCrispUser(crispUser: CrispUser) {
    if (crispUser) {
      Object.keys(crispUser).forEach((k) => !crispUser[k] && delete crispUser[k]);
    }
    return crispUser;
  }
}
